import { render, staticRenderFns } from "./topBBooking.vue?vue&type=template&id=482ead30&scoped=true&"
import script from "./topBBooking.vue?vue&type=script&lang=js&"
export * from "./topBBooking.vue?vue&type=script&lang=js&"
import style0 from "./topBBooking.vue?vue&type=style&index=0&id=482ead30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ead30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
